import { Dispatch, SetStateAction } from 'react';


export const useDragnDrop = () => {

  const moveItem = (fromIndex, toIndex, values) => {
    const updatedDragnDropItem = [...values];
    const [movedItem] = updatedDragnDropItem.splice(fromIndex, 1);
    updatedDragnDropItem.splice(toIndex, 0, movedItem);
    return updatedDragnDropItem;
  };


  const onDragEnd = (result, values, setvalue: Dispatch<SetStateAction<any[]>>) => {
    if (!result.destination) {
      return;
    }
    setvalue(moveItem(result.source.index, result.destination.index, values));
  };

  const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? 'lightblue' : 'none',
    padding: 10,
  });


  return {
    onDragEnd,
    getListStyle,
  };
};